import RenderHTML from '../../../../components/ui-components/RenderHTML'
import { ChevronIcon } from '../../components/ChevronIcon'
import { GainType } from '../../types/summary.types'

export type TaxPlanCardProps = {
  label: string
  amount: string
  taxLiability: string
  highlightTitle: string
  highlightSubtitle: string
  secondaryHighlightTitle?: string
  secondaryHighlightSubtitle?: string
  onClick?: () => void
  /** Called when the secondary highlight row is clicked (e.g. non-equity plan); use to open plan page on non-equity tab */
  onSecondaryHighlightClick?: () => void
  onSummaryClick?: () => void
  onTaxLiabilityClick?: () => void
  showNoOpportunity?: boolean
  /** When showNoOpportunity is true, used for NoTaxSavings subtitle (LTCG vs STCG) */
  gainType?: GainType
}

export function TaxPlanCard({
  label,
  amount,
  taxLiability,
  highlightTitle,
  highlightSubtitle,
  secondaryHighlightTitle,
  secondaryHighlightSubtitle,
  onClick,
  onSecondaryHighlightClick,
  onSummaryClick,
  onTaxLiabilityClick,
  showNoOpportunity,
  gainType = GainType.LTCG
}: TaxPlanCardProps) {
  // Tax summary_B19 — Excel expected hints (iOS). Prefer aria-description; keep name = label + amount.
  const summaryHint =
    gainType === GainType.STCG
      ? 'Double tap to view STCG details'
      : 'Double tap to view LTCG details'

  return (
    <div className='mt-3 rounded-[16px] bg-white border border-[#EBF2F2] py-4'>
      <div className='flex items-start justify-between px-5'>
        <button
          type='button'
          onClick={onSummaryClick}
          aria-label={`${label}, ${amount}`}
          aria-description={summaryHint}
          className='flex items-center gap-1 text-sm text-grey40 cursor-pointer bg-transparent border-none px-0 py-[4px] -my-[4px]'
        >
          <span aria-hidden='true'><RenderHTML innerHTMLText={label} /></span>
          <span aria-hidden className='text-[16px] leading-none text-[#8E9393]'>
            <RenderHTML innerHTMLText={ChevronIcon} />
          </span>
        </button>
        <span aria-hidden='true' className='text-sm font-medium text-[#232323]'>{amount}</span>
      </div>
      <div className='mt-4 flex justify-between text-sm text-grey40 px-5'>
        <button
          type='button'
          onClick={onTaxLiabilityClick}
          aria-label={`Tax liability, ${taxLiability}`}
          aria-description='Double tap to view tax liability details'
          className='flex items-center gap-1 text-sm text-grey40 cursor-pointer bg-transparent border-none px-0 py-[4px] -my-[4px]'
        >
          <span aria-hidden='true'>Tax liability</span>
          <span aria-hidden className='text-[16px] leading-none text-[#8E9393]'>
            <RenderHTML innerHTMLText={ChevronIcon} />
          </span>
        </button>
        <span aria-hidden='true' className='text-sm font-medium text-[#232323]'>{taxLiability}</span>
      </div>
      {/* TODO: Uncomment whenever necessary after Apr 1 */}
      {/* <div className='mt-5 w-full rounded-[12px] text-left px-1 pb-1'>
        {showNoOpportunity ? (
          <NoTaxSavings gainType={gainType} taxLiability={taxLiability} onClick={onClick} />
        ) : (
          <div
            className='rounded-[12px] bg-[#FFF2DF] overflow-hidden cursor-pointer'
          >
            <div onClick={onClick} className='px-4 py-3 flex items-center justify-between gap-3'>
              <div>
                <div className='text-sm font-medium text-[#992E00]'><RenderHTML innerHTMLText={highlightTitle} /></div>
                <div className='text-[13px] text-[#992E00] opacity-50'><RenderHTML innerHTMLText={highlightSubtitle} /></div>
              </div>
              <span aria-hidden className='text-[#992E00]'>
                <RightChevron fill='#992E00' />
              </span>
            </div>
            {secondaryHighlightTitle && (
              <>
                <div className='h-px bg-white' />
                <div
                  onClick={onSecondaryHighlightClick}
                  className='px-4 py-3 flex items-center justify-between gap-3 cursor-pointer'
                >
                  <div>
                    <div className='text-sm font-medium text-[#992E00]'><RenderHTML innerHTMLText={secondaryHighlightTitle} /></div>
                    <div className='text-[13px] text-[#992E00] opacity-50'>
                      <RenderHTML innerHTMLText={secondaryHighlightSubtitle ?? ''} />
                    </div>
                  </div>
                  <span aria-hidden className='text-[#992E00]'>
                    <RightChevron fill='#992E00' />
                  </span>
                </div>
              </>
            )}
          </div>
        )}
      </div> */}
    </div>
  )
}
